/*
 * Title: Successfull/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Successfully sign up popup.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Lottie from 'react-lottie'
import successGif from "@assets/lotties/success.json";
type Props = {};

const Joined: React.FC<Props> = props => {
  React.useEffect(() => {
    const interval = setInterval(() => {
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: successGif,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
};
  return (
    <Transition.Root show={true} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => true}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#000]/80 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-full p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative w-screen h-full overflow-hidden pointer-events-auto">
                <div className="flex flex-col items-center justify-center text-center">
                  <Lottie options={defaultOptions} height={242} width={242} />
                  <h4 className="font-medium text-white text-[36px] text-center">
                    You joined Encore!
                  </h4>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Joined;
